import apiClient from '../lib/apiClient';

// Get all leads with optional filtering
const getLeads = async (filters = {}) => {
  try {
    const result = await apiClient.get('/crm', filters);
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to fetch leads' };
  }
};

// Get leads assigned to current telecaller
const getAssignedLeads = async (telecallerId) => {
  try {
    const result = await apiClient.get(`/crm/assigned/${telecallerId}`);
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to fetch assigned leads' };
  }
};

// Create a new lead
const createLead = async (leadData) => {
  try {
    const result = await apiClient.post('/crm', leadData);
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to create lead' };
  }
};

// Update lead information
const updateLead = async (leadId, updates) => {
  try {
    const result = await apiClient.put(`/crm/${leadId}`, updates);
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to update lead' };
  }
};

// Assign lead to telecaller
const assignLeadToTelecaller = async (leadId, telecallerId) => {
  try {
    const result = await apiClient.post('/crm/assign', {
      lead_id: leadId,
      telecaller_id: telecallerId
    });
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to assign lead to telecaller' };
  }
};

// Log a call interaction
const logCall = async (callData) => {
  try {
    const result = await apiClient.post('/crm/logCall', callData);
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to log call' };
  }
};

// Get call history for a lead
const getLeadCallHistory = async (leadId) => {
  try {
    const result = await apiClient.get(`/crm/${leadId}/calls`);
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to fetch call history' };
  }
};

// Validate a lead
const validateLead = async (leadId, isValid, notes = '') => {
  try {
    const result = await apiClient.post('/crm/validate', {
      lead_id: leadId,
      is_valid: isValid,
      notes: notes
    });
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to validate lead' };
  }
};

// Get telecaller performance metrics
const getTelecallerMetrics = async (telecallerId, dateRange = 7) => {
  try {
    const result = await apiClient.get(`/crm/metrics/${telecallerId}`, { dateRange });
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to fetch telecaller metrics' };
  }
};

// Get lead pipeline stats
const getLeadPipelineStats = async () => {
  try {
    const result = await apiClient.get('/crm/pipeline');
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to fetch pipeline stats' };
  }
};

// Send lead to client requirement
const sendLeadToClient = async (leadId, submissionData) => {
  try {
    const result = await apiClient.post('/crm/sendToClient', {
      lead_id: leadId,
      requirement_id: submissionData.requirement_id,
      notes: submissionData.notes || null
    });
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to send lead to client' };
  }
};

// Get submission history for a lead
const getLeadSubmissions = async (leadId) => {
  try {
    const result = await apiClient.get(`/crm/${leadId}/submissions`);
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to fetch lead submissions' };
  }
};

// Update client response for a lead submission
const updateLeadSubmissionStatus = async (submissionId, clientResponse, clientNotes = '') => {
  try {
    const result = await apiClient.post('/crm/updateClientResponse', {
      submission_id: submissionId,
      response: clientResponse,
      notes: clientNotes
    });
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to update lead submission status' };
  }
};

// Get telecaller users
const getTelecallers = async () => {
  try {
    const result = await apiClient.get('/crm/telecallers');
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to fetch telecallers' };
  }
};

// Delete a lead
const deleteLead = async (leadId) => {
  try {
    const result = await apiClient.delete(`/crm/${leadId}`);
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to delete lead' };
  }
};

// Get HR users
const getHRs = async () => {
  try {
    const result = await apiClient.get('/crm/hrs');
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to fetch HRs' };
  }
};

// Assign lead to HR
const assignLeadToHR = async (leadId, hrId) => {
  try {
    const result = await apiClient.post('/crm/assignHR', {
      lead_id: leadId,
      hr_id: hrId
    });
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to assign lead to HR' };
  }
};

export default {
  getLeads,
  getAssignedLeads,
  createLead,
  updateLead,
  deleteLead,
  assignLeadToTelecaller,
  assignLeadToHR,
  logCall,
  getLeadCallHistory,
  validateLead,
  getTelecallerMetrics,
  getLeadPipelineStats,
  sendLeadToClient,
  getLeadSubmissions,
  updateLeadSubmissionStatus,
  getTelecallers,
  getHRs
};
